import type { SVGProps } from 'react';

/** Stroke icon paths used across the design (24×24 viewBox, 1.75 stroke). */
export const ICON_PATHS = {
  home: 'M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z',
  inbox: 'M3 13h5l2 3h4l2-3h5M5 5h14l2 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6z',
  dashboards: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  building: 'M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16M15 9h4a1 1 0 0 1 1 1v11M3 21h18M8 8h3M8 12h3M8 16h3',
  person: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
  currency:
    'M12 3v18M16.5 7.5c0-1.7-2-3-4.5-3s-4.5 1.3-4.5 3 2 2.6 4.5 3 4.5 1.3 4.5 3-2 3-4.5 3-4.5-1.3-4.5-3',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  list: 'M4 6h10M8 12h12M6 18h8',
  badge: 'M6 3h12v18H6zM12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM9 16h6',
  briefcase: 'M3 8h18v11H3zM8 8V5h8v3',
  box: 'M12 3l8 4.5v9L12 21l-8-4.5v-9zM4 7.5l8 4.5 8-4.5M12 12v9',
  task: 'M9 11l3 3 8-8M20 12v7a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h11',
  folder: 'M3 7V5h6l2 2h10v13H3z',
  file: 'M6 3h9l5 5v13H6zM14 3v6h6',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z',
  view: 'M4 6h16M4 12h16M4 18h10',
  bolt: 'M13 3L5 14h6l-1 7 8-11h-6z',
  sliders: 'M4 7h10M18 7h2M4 17h4M12 17h8M16 5v4M10 15v4',
  members:
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21a7 7 0 0 1 14 0M16 3.5a4 4 0 0 1 0 7.5M18 14a6 6 0 0 1 4 7',
  lock: 'M6 11h12v10H6zM8 11V8a4 4 0 0 1 8 0v3',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  database:
    'M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  schema: 'M7 8h13M16 4l4 4-4 4M17 16H4M8 12l-4 4 4 4',
  layers: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  plug: 'M9 3v5M15 3v5M6 8h12v3a6 6 0 0 1-12 0zM12 17v4',
  check: 'M5 12l5 5 9-10',
  code: 'M8 9l-4 3 4 3M16 9l4 3-4 3M13 6l-2 12',
  pulse: 'M3 12h4l3-8 4 16 3-8h4',
  rows: 'M4 6h16M4 12h16M4 18h16',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4',
  plus: 'M12 5v14M5 12h14',
  x: 'M7 7l10 10M17 7L7 17',
  'chevron-down': 'M6 9l6 6 6-6',
  'chevron-up': 'M6 15l6-6 6 6',
  'chevron-right': 'M9 6l6 6-6 6',
  'chevron-left': 'M15 6l-6 6 6 6',
  'chevron-updown': 'M8 10l4-4 4 4M8 14l4 4 4-4',
  'arrow-left': 'M19 12H5M11 6l-6 6 6 6',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  grip: 'M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01',
  bell: 'M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21h4',
  upload: 'M12 16V4M7 9l5-5 5 5M4 20h16',
  download: 'M12 4v12M7 11l5 5 5-5M4 20h16',
  filter: 'M4 5h16l-6 8v6l-4-2v-4z',
  sort: 'M7 4v16M3 16l4 4 4-4M17 20V4M13 8l4-4 4 4',
  board: 'M4 5h4v14H4zM10 5h4v9h-4zM16 5h4v11h-4z',
  table: 'M4 5h16v14H4zM4 10h16M10 10v9',
  columns: 'M4 5h16v14H4zM10 5v14M16 5v14',
  timeline: 'M4 6h10M8 12h12M6 18h8',
  gallery: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  form: 'M4 5h16v14H4zM8 9h8M8 13h5',
  map: 'M9 4L3 6v14l6-2 6 2 6-2V4l-6 2zM9 4v14M15 6v14',
  comment: 'M4 5h16v11H9l-5 4z',
  play: 'M7 4l13 8-13 8z',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  refresh: 'M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M18 3v4h-4M6 21v-4h4',
  alert: 'M12 9v4M12 17h.01M10.3 3.9L2 18a2 2 0 0 0 1.7 3h16.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 8h.01M11 12h1v4h1',
  sparkle: 'M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M6 18l2.5-2.5M15.5 8.5L18 6',
  globe:
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z',
  pencil: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  branch: 'M6 3v6a6 6 0 0 0 6 6h6M15 12l3 3-3 3M6 21v-6',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  merge:
    'M6 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM6 20.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 20.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM6 8.5v7M18 15.5V10a3 3 0 0 0-3-3h-2.5M15 4l-3 3 3 3',
  issue: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 12h.01',
  commit: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3 12h6M15 12h6',
  trash: 'M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3',
  copy: 'M9 9h11v11H9zM5 15V4h11',
  // Copy with a plus: a second one of the same (Duplicate), unlike Copy to the clipboard.
  duplicate: 'M9 9h11v11H9zM5 15V4h11M14.5 12.5v5M12 15h5',
  // A board with a clip (Paste).
  clipboard: 'M8 5H5v16h14V5h-3M9 3h6v4H9z',
  // A key: ring, long shaft and two teeth (reads as a key at 14px, unlike a pin).
  key: 'M13 15.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zM21 2l-9.6 9.6M15.5 7.5l3 3L22 7l-3-3',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  logout: 'M15 4h4v16h-4M10 17l5-5-5-5M15 12H4',
  // Text formatting and lists (the page editor, slides and the mail composer share one drawing of each).
  bold: 'M7 5h6a3.5 3.5 0 0 1 0 7H7zM7 12h7a3.5 3.5 0 0 1 0 7H7z',
  italic: 'M14 5h-4M14 19h-4M14 5l-4 14',
  underline: 'M7 4v7a5 5 0 0 0 10 0V4M5 20h14',
  strike: 'M5 12h14M16 6.5C15 5 13.5 4.5 12 4.5c-2.5 0-4 1.5-4 3.3 0 1.2.8 2 2 2.6M8.5 17c1 1.7 2.5 2.5 4 2.5 2.5 0 4-1.5 4-3.5 0-.8-.3-1.5-.8-2',
  bullets: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  numbers: 'M10 6h10M10 12h10M10 18h10M4 6h1v4M4 10h2M4 14h2l-2 3h2',
  quote: 'M6 17c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3h2v6H5M16 17c-1.7 0-3-1.3-3-3V9c0-1.7 1.3-3 3-3h2v6h-3',
  divider: 'M4 12h16',
  // Editor chrome (moved from editor-kit's EK_ICONS, design-system wave 2).
  undo: 'M9 14L4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11',
  redo: 'M15 14l5-5-5-5M20 9H9.5a5.5 5.5 0 0 0 0 11H13',
  history: 'M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5M12 7v5l3 2',
  'cloud-off': 'M3 3l18 18M8.5 8.6A4.5 4.5 0 0 0 7 17h10M20.3 15.7A4 4 0 0 0 17 9h-.6A6 6 0 0 0 10.7 5',
  'cloud-check': 'M7 18a5 5 0 1 1 1.2-9.9A6 6 0 0 1 19.6 11 3.5 3.5 0 0 1 18 18zM9.5 13.5l2 2 3.5-4',
  publish: 'M12 16V4M7 9l5-5 5 5M5 20h14',
  minus: 'M5 12h14',
  'zoom-in': 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM20 20l-4-4M8 11h6M11 8v6',
  template: 'M4 4h7v7H4zM13 4h7v4h-7zM13 10h7v10h-7zM4 13h7v7H4z',
  'panel-left': 'M4 5h16v14H4zM9 5v14',
  restore: 'M4 12a8 8 0 1 0 2.3-5.7L4 8.6M4 4v4.6h4.6',
  'diff-add': 'M12 7v10M7 12h10',
  'diff-remove': 'M7 12h10',
  'diff-change': 'M5 19h4L18.5 9.5l-4-4L5 15zM12.5 7.5l4 4',
  'diff-move': 'M8 4v16M4 16l4 4 4-4M16 20V4M12 8l4-4 4 4',
  fix: 'M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.4-.6-.6-2.4z',
  // design-system wave 2.
  'eye-off':
    'M3 3l18 18M10.6 6.1A9.8 9.8 0 0 1 12 6c5 0 9 6 9 6a17 17 0 0 1-2.6 3.2M6.4 6.5C4 8.2 3 12 3 12s4 6 9 6a8.6 8.6 0 0 0 4.1-1M9.9 9.9a3 3 0 0 0 4.2 4.2',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z',
  monitor: 'M3 4h18v12H3zM8 20h8M12 16v4',
  palette:
    'M12 21a9 9 0 1 1 9-9c0 2.5-2 3-3.5 3H16a2 2 0 0 0-1.4 3.4A1.6 1.6 0 0 1 12 21zM7.5 11.5h.01M10.5 7.5h.01M15.5 8.5h.01',
  type: 'M5 6V4h14v2M12 4v16M9 20h6',
  image: 'M4 4h16v16H4zM4 16l5-5 4 4 2-2 5 5M15.5 9.5h.01',
  keyboard: 'M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M18 10h.01M7 14h10',
  hash: 'M5 9h14M5 15h14M10 4L8 20M16 4l-2 16',
  heading: 'M6 4v16M18 4v16M6 12h12',
  embed: 'M4 5h16v14H4zM8 12h8M13 9l3 3-3 3',
  video: 'M3 7h12v10H3zM15 11l6-3.5v9L15 13',
  pin: 'M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  // meeting recorder (F15).
  mic: 'M12 3a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3zM5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M9 21h6',
  pause: 'M8 5v14M16 5v14',
  // custom components (F20): a puzzle piece for a component, a square for stop, four tiles for an app.
  puzzle:
    'M19.4 7.9c-.05.32.06.65.29.88l1.57 1.57c.47.47.71 1.09.71 1.7s-.24 1.23-.71 1.7l-1.61 1.61a.98.98 0 0 1-.84.28c-.47-.07-.8-.48-.97-.93a2.5 2.5 0 1 0-3.21 3.21c.45.17.86.5.93.97a.98.98 0 0 1-.28.84l-1.61 1.61a2.4 2.4 0 0 1-1.7.7 2.4 2.4 0 0 1-1.7-.7l-1.57-1.57a1.03 1.03 0 0 0-.88-.29c-.49.07-.84.5-1.02.97a2.5 2.5 0 1 1-3.24-3.24c.46-.18.89-.53.97-1.02a1.03 1.03 0 0 0-.29-.88l-1.57-1.57A2.4 2.4 0 0 1 2 12c0-.62.24-1.23.71-1.7L4.23 8.77c.24-.24.58-.35.92-.3.52.08.88.53 1.07 1.01a2.5 2.5 0 1 0 3.26-3.26c-.48-.2-.93-.56-1.01-1.07-.05-.34.06-.68.3-.92l1.53-1.53A2.4 2.4 0 0 1 12 2c.62 0 1.23.24 1.7.71l1.57 1.57c.23.23.56.34.88.29.49-.07.84-.5 1.02-.97a2.5 2.5 0 1 1 3.24 3.24c-.46.18-.89.53-.97 1.02Z',
  stop: 'M7 7h10v10H7z',
  app: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  // component building blocks (F21 fix round): distinct glyphs for layout variants, time and data blocks, so palette tiles
  // can be told apart at 16px.
  'columns-2': 'M4 5h16v14H4zM12 5v14',
  'columns-3': 'M4 5h16v14H4zM9.3 5v14M14.7 5v14',
  'layout-sidebar': 'M4 5h16v14H4zM15 5v14M6.5 9h5M6.5 12h5',
  split: 'M4 5h16v14H4zM12 5v14M7.5 12h2M14.5 12h2',
  drawer: 'M4 5h16v14H4zM14 5v14M16.5 9h1.5M16.5 12h1.5M16.5 15h1.5',
  section: 'M4 4h16v16H4zM4 9h16M7.5 14h9',
  scroll: 'M5 4h12v16H5zM8 8h6M8 12h6M20 6v12',
  spacer: 'M12 4v16M9 7l3-3 3 3M9 17l3 3 3-3',
  tag: 'M3 12V4h8l10 10-8 8zM7.5 8.5h.01',
  trend: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  gauge: 'M4 18a8 8 0 0 1 16 0M12 18l4-6M6 18h.01M18 18h.01',
  progress: 'M4 9h16v6H4zM4 9h9v6H4z',
  'line-chart': 'M3 20h18M4 15l5-5 4 3 7-8',
  agenda: 'M4 5h16v14H4zM8 9h8M8 12h8M8 15h5',
  heatmap: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  datagrid: 'M4 5h16v14H4zM4 10h16M4 15h16M10 5v14M16 5v14',
  schedule: 'M3 5h18v15H3zM3 9h18M8 9v11M13 9v11M18 9v11',
  heatcal: 'M4 6h16v14H4zM8 3v4M16 3v4M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15h.01',
  week: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4M9 10v10M15 10v10',
  gantt: 'M4 3v18M7 6h9M10 12h10M7 18h7',
  fieldset: 'M5 4h14v6H5zM5 14h14v6H5zM8 7h6M8 17h6',
  signature: 'M3 17c2.5-6 4.5-8 6-6s1 5 3 4 2.5-5 4-5 1.5 3 5 2M4 21h16',
  buttons: 'M3 8h8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3zM15 8h6v5h-6z',
  stopwatch: 'M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 9v4l2 2M10 2h4M18.5 6.5l1.5-1.5',
  hourglass: 'M7 3h10M7 21h10M8 3c0 5 4 5 4 9s-4 4-4 9M16 3c0 5-4 5-4 9s4 4 4 9',
  qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h3v3h-3zM19 14h1M14 19h2M19 17v3h-3',
  barcode: 'M4 5v14M7 5v14M10.5 5v14M14 5v14M17 5v14M20 5v14',
  hero: 'M3 5h18v14H3zM7 10h7M7 13.5h10',
  radio: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  chips: 'M4 6h9a3 3 0 0 1 0 6H4a3 3 0 0 1 0-6zM9 14h8a3 3 0 0 1 0 6H9a3 3 0 0 1 0-6z',
} as const;

export type IconName = keyof typeof ICON_PATHS;

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'name'> & {
  name?: IconName;
  /** Custom path data (24×24) when the icon is not in the set. */
  path?: string;
  size?: number;
  strokeWidth?: number;
  /** Accessible label; omit for decorative icons (aria-hidden). */
  label?: string;
};

export function Icon({ name, path, size = 16, strokeWidth, label, className, style, ...rest }: IconProps) {
  const d = path ?? (name ? ICON_PATHS[name] : undefined);
  // Dot glyphs (more, grip) need a heavier stroke to read at 16px, as in the design.
  const stroke = strokeWidth ?? (name === 'more' || name === 'grip' ? 3 : undefined);
  return (
    <svg
      viewBox="0 0 24 24"
      className={className ? `i ${className}` : 'i'}
      style={{ width: size, height: size, ...(stroke ? { strokeWidth: stroke } : {}), ...style }}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      {...rest}
    >
      {d ? <path d={d} /> : null}
    </svg>
  );
}
